import { Divider } from '@wix/design-system';
import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';
import s from './SectionWrapper.module.scss';

interface SectionWrapperProps extends HTMLAttributes<HTMLElement> {
  sectionId: string;
  children: any;
  className?: string;
  showDivider?: boolean;
  visible?: boolean;
}

const SectionWrapper = React.forwardRef(
  (props: SectionWrapperProps, ref: any) => {
    const {
      sectionId,
      children,
      className,
      showDivider = false,
      visible = true,
      ...restProps
    } = props;

    if (!visible) {
      return null;
    }

    return (
      <>
        <section
          id={sectionId}
          tabIndex={-1}
          ref={(el) => {
            if (ref?.current) {
              ref.current[sectionId] = el;
            }
          }}
          className={clsx(s.navigationSection, className)}
          {...restProps}
        >
          {children}
        </section>
        {showDivider && <Divider className={s.divider} />}
      </>
    );
  },
);

export default SectionWrapper;
